import { render, staticRenderFns } from "./ornament-bg.vue?vue&type=template&id=3d74312e&"
import script from "./ornament-bg.vue?vue&type=script&lang=js&"
export * from "./ornament-bg.vue?vue&type=script&lang=js&"
import style0 from "./ornament-bg.vue?vue&type=style&index=0&id=3d74312e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconOrnament: require('/opt/airport.kg/src/components/icon/ornament.vue').default})
